/**
 * Tolerant coercion helpers for API payloads.
 *
 * The backend serializes decimals (and sometimes counts) as strings, so parse
 * defensively instead of assuming numeric or using bare `Number()` (which
 * yields NaN on non-numeric strings). Returns `fallback` for
 * null/undefined/non-finite/unparseable input.
 *
 * Consolidated from the copies that were duplicated across the repositories
 * and view-models.
 */
export function toNumber(v: any, fallback = 0): number {
  if (v == null) return fallback;
  if (typeof v === "number") return Number.isFinite(v) ? v : fallback;
  if (typeof v === "string") {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : fallback;
  }
  return fallback;
}

export function toNumOrNull(v: any): number | null {
  const n = toNumber(v, NaN);
  return Number.isFinite(n) ? n : null;
}

/** boolean 그대로, 1/0 은 true/false, 나머지는 fallback. */
export function toBool(v: any, fallback = false): boolean {
  if (typeof v === "boolean") return v;
  if (v === 1) return true;
  if (v === 0) return false;
  return fallback;
}

/** 배열이 아니면 [] — 빈 문자열은 거른다. */
export function toStrArray(v: any): string[] {
  if (!Array.isArray(v)) return [];
  return v.map((x) => String(x ?? "")).filter(Boolean);
}

/** 목록 페이지네이션 — total_page 가 없으면 total_pages 로 대체. */
export function normalizePagination(pg: any) {
  return {
    total_items: toNumber(pg?.total_items, 0),
    current_page: toNumber(pg?.current_page, 1),
    total_page: toNumber(pg?.total_page ?? pg?.total_pages, 1),
  };
}
